import {useEffect, useState} from "react";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {ThinChevronRight, ThinConsentIcon} from "../../../components/icons/material-icons";
import {Link} from "react-router-dom";

interface consentInterface {
    nd: string,
    title: string,
    signed: boolean,
    createdAt: string,
}

export const StudentsConsentsListScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState<consentInterface[]>([]);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/parents/consents/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: consentInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "رضایت‌نامه‌ها | نهال";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'رضایت‌نامه ها', url: '/students/consents'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="screen-card" style={{marginBottom: 0}}>
                            <div className="screen-card-header">
                                <b>رضایت‌نامه ها</b>
                            </div>
                            {
                                list.length < 1 ?
                                    <div className="staff--not-found">
                                        <em style={{backgroundImage: 'url(/svg/consent.svg)'}}/>
                                        <b>رضایت‌نامه ای یافت نشد</b>
                                        <p>به نظر می‌رسد برای شما هنوز رضایت‌نامه ای صادر نشده است.</p>
                                    </div> :
                                    null
                            }
                            {
                                list.map((p, i) =>
                                    <Link to={`/students/consents/view/${p.nd}`} className="extra-payment-item"
                                          key={"AAjm39fj22Ffjd39i2" + i}>
                                        <div>
                                            <i><ThinConsentIcon/></i>
                                            <div>
                                                <b>{p.title}</b>
                                                <span>{p.signed ? 'امضا شده' : 'هنوز امضا نشده است'}</span>
                                            </div>
                                        </div>
                                        <em>
                                            {p.signed ? 'مشاهده' : 'امضا'}
                                            <ThinChevronRight/>
                                        </em>
                                    </Link>
                                )
                            }
                        </div>
                    </div> : null
            }
        </>
    );
};